const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3000/api";

const getStoredRefreshToken = () => localStorage.getItem("refreshToken");
const getStoredAccessToken = () => localStorage.getItem("authToken");

export const saveAuthSession = ({ accessToken, refreshToken, user }) => {
  if (accessToken) {
    localStorage.setItem("authToken", accessToken);
  }
  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
  }
  if (user) {
    localStorage.setItem("authUser", JSON.stringify(user));
  }
};

export const clearAuthSession = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("authUser");
};

const tryRefreshToken = async () => {
  const refreshToken = getStoredRefreshToken();
  if (!refreshToken) {
    return null;
  }

  const response = await fetch(`${API_BASE_URL}/auth/refresh`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refreshToken }),
  });

  if (!response.ok) {
    return null;
  }

  const data = await response.json();
  saveAuthSession(data);
  return data.accessToken;
};

export const apiRequest = async (path, options = {}) => {
  const {
    method = "GET",
    auth = false,
    body,
    headers = {},
    retryOnUnauthorized = true,
  } = options;

  const requestHeaders = { ...headers };
  const isFormData = typeof FormData !== "undefined" && body instanceof FormData;

  if (body !== undefined && !isFormData && !requestHeaders["Content-Type"]) {
    requestHeaders["Content-Type"] = "application/json";
  }

  if (auth) {
    const accessToken = getStoredAccessToken();
    if (accessToken) {
      requestHeaders.Authorization = `Bearer ${accessToken}`;
    }
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: requestHeaders,
    body:
      body === undefined
        ? undefined
        : isFormData
          ? body
          : JSON.stringify(body),
  });

  if (response.status === 401 && auth && retryOnUnauthorized && path !== "/auth/refresh") {
    const refreshedToken = await tryRefreshToken();
    if (refreshedToken) {
      return apiRequest(path, {
        ...options,
        retryOnUnauthorized: false,
      });
    }

    clearAuthSession();
  }

  if (response.status === 204) {
    return null;
  }

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    const message = Array.isArray(data?.message) ? data.message[0] : data?.message;
    const error = new Error(message || "Request failed.");
    error.status = response.status;
    throw error;
  }

  return data;
};

export { API_BASE_URL };
